import gql from "graphql-tag";

export const gqlQuery = gql`
  query Recording($recordingId: ID) {
    recording(recordingId: $recordingId) {
      id
      created
      description
      eventId
      customerId
      event {
        id
        title
        startDate
        endDate
        eventStatus
        customerId
      }
      deployment {
        id
        codename
      }
      availableFiles {
        fileId
        type
        format
        url
        geometry
        resolution
        downloadAvailable
        path
      }
      expirationDate
    }
  }
`;

export default ({ recordingId, customerId, hasAdminPrivileges }) => ({
  query: gqlQuery,
  skip: !recordingId || (!customerId && !hasAdminPrivileges),
  variables: { recordingId, customerId },
});
